// AUTO-GENERATED by packages/emerald-converter/src/extract-battlefx-cli.ts.
// Do not edit by hand. Run `pnpm --filter @poke/emerald-converter extract-battlefx`
// to regenerate. Cartridge battle-anim pixels; motion is Phaser-side.
// Each entry's `source` records sheet + palette provenance in the decomp.

export interface BattleFxSheet {
  fxType: string;
  frameWidth: number;
  frameHeight: number;
  frameCount: number;
  source: string;
}

export const BATTLE_FX_MANIFEST: Record<string, BattleFxSheet> = {
  "impact": {
    "fxType": "normal",
    "frameWidth": 32,
    "frameHeight": 32,
    "frameCount": 1,
    "source": "impact.png (gBattleAnimSpriteGfx_Impact)"
  },
  "ember": {
    "fxType": "fire",
    "frameWidth": 32,
    "frameHeight": 32,
    "frameCount": 5,
    "source": "small_ember.png (gBattleAnimSpriteGfx_SmallEmber)"
  },
  "droplet": {
    "fxType": "water",
    "frameWidth": 32,
    "frameHeight": 32,
    "frameCount": 8,
    "source": "water_droplet.png (gBattleAnimSpriteGfx_WaterDroplet)"
  },
  "spark": {
    "fxType": "electric",
    "frameWidth": 8,
    "frameHeight": 8,
    "frameCount": 8,
    "source": "spark_0.png + spark.pal (gBattleAnimSpriteGfx_Spark0 + Pal_Spark)"
  },
  "leaf": {
    "fxType": "grass",
    "frameWidth": 16,
    "frameHeight": 16,
    "frameCount": 9,
    "source": "leaf.png (gBattleAnimSpriteGfx_Leaf)"
  },
  "ice-crystal": {
    "fxType": "ice",
    "frameWidth": 16,
    "frameHeight": 16,
    "frameCount": 1,
    "source": "ice_crystals_0.png + ice_crystals.pal (gBattleAnimSpriteGfx_IceCrystals0 + Pal_IceCrystals)"
  },
  "punch": {
    "fxType": "fighting",
    "frameWidth": 32,
    "frameHeight": 32,
    "frameCount": 1,
    "source": "punch_impact.png (gBattleAnimSpriteGfx_PunchImpact)"
  },
  "poison-bubble": {
    "fxType": "poison",
    "frameWidth": 16,
    "frameHeight": 16,
    "frameCount": 3,
    "source": "poison_bubble.png (gBattleAnimSpriteGfx_PoisonBubble)"
  },
  "mud": {
    "fxType": "ground",
    "frameWidth": 8,
    "frameHeight": 8,
    "frameCount": 1,
    "source": "mud_sand_0.png + mud_sand.pal (gBattleAnimSpriteGfx_MudSand0 + Pal_MudSand)"
  },
  "gust": {
    "fxType": "flying",
    "frameWidth": 32,
    "frameHeight": 32,
    "frameCount": 2,
    "source": "gust.png (gBattleAnimSpriteGfx_Gust)"
  },
  "rainbow-ring": {
    "fxType": "psychic",
    "frameWidth": 8,
    "frameHeight": 8,
    "frameCount": 6,
    "source": "rainbow_rings.png (gBattleAnimSpriteGfx_RainbowRings)"
  },
  "pin": {
    "fxType": "bug",
    "frameWidth": 16,
    "frameHeight": 16,
    "frameCount": 1,
    "source": "green_spike.png (gBattleAnimSpriteGfx_GreenSpike)"
  },
  "rocks": {
    "fxType": "rock",
    "frameWidth": 32,
    "frameHeight": 32,
    "frameCount": 6,
    "source": "rocks.png (gBattleAnimSpriteGfx_Rocks)"
  },
  "shadow-ball": {
    "fxType": "ghost",
    "frameWidth": 8,
    "frameHeight": 8,
    "frameCount": 1,
    "source": "black_ball.png + black_ball.pal (gBattleAnimSpriteGfx_BlackBall + Pal_BlackBall)"
  },
  "dragon-flame": {
    "fxType": "dragon",
    "frameWidth": 32,
    "frameHeight": 32,
    "frameCount": 2,
    "source": "blue_flames.png (gBattleAnimSpriteGfx_BlueFlames)"
  },
  "claw": {
    "fxType": "dark",
    "frameWidth": 32,
    "frameHeight": 32,
    "frameCount": 5,
    "source": "claw_slash.png (gBattleAnimSpriteGfx_ClawSlash)"
  },
  "shrapnel": {
    "fxType": "steel",
    "frameWidth": 32,
    "frameHeight": 32,
    "frameCount": 4,
    "source": "torn_metal.png (gBattleAnimSpriteGfx_TornMetal)"
  }
};
